<template>
    <div :class="isAfert ? 'entity-compare-after' : ''">
        <div>
            <div class="tab-sub-heading">
                <h3>{{ t('collection-centre::form.title.general_information') }}</h3>
            </div>
            <div class="notification-field name">
                <label class="label"
                    >{{ t('collection-centre::form.label.name') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.name }}</div>
            </div>
            <div class="notification-field is_registered">
                <label class="label">{{ t('collection-centre::form.label.registered') }}</label>
                <div class="value">{{ getStatus(store.is_registered) }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('collection-centre::form.title.address') }}</h3>
            </div>
            <div class="notification-field address">
                <label class="label"
                    >{{ t('collection-centre::form.label.address') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.address }}</div>
            </div>
            <div class="notification-field post_code">
                <label class="label"
                    >{{ t('collection-centre::form.label.post_code') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.post_code }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('collection-centre::form.title.contact_details') }}</h3>
            </div>
            <div class="notification-field phone">
                <label class="label"
                    >{{ t('collection-centre::form.label.phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.phone }}</div>
            </div>
            <div class="notification-field fax">
                <label class="label">{{ t('collection-centre::form.label.fax') }}</label>
                <div class="value">{{ store.fax }}</div>
            </div>
            <div class="notification-field email">
                <label class="label"
                    >{{ t('collection-centre::form.label.email') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.email }}</div>
            </div>
            <div class="notification-field contacts_information">
                <label class="label">{{ t('collection-centre::form.label.contacts') }}</label>
                <div class="value">{{ store.contacts_information }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('collection-centre::form.title.courier') }}</h3>
            </div>

            <div class="notification-field courier_details">
                <label class="label"
                    >{{ t('collection-centre::form.label.courier_details') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.courier_details }}</div>
            </div>
            <div class="notification-field courier_phone">
                <label class="label"
                    >{{ t('collection-centre::form.label.courier_phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.courier_phone }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificationCollectionCentresApprovalRequestForm',
    components: {},
    props: {
        store: {
            type: Object,
            required: true,
        },
        isAfert: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        updatedProps() {
            return this.$store.state.notification_laboratory.updatedProps.map((x) => x.replace('.', '-'));
        },
    },
    watch: {
        updatedProps() {
            this.setActiveItems();
        },
    },
    mounted() {
        this.setActiveItems();
    },
    created() {},
    methods: {
        getStatus(status) {
            return status ? 'True' : 'False';
        },
        setActiveItems() {
            if (!this.updatedProps.length) {
                return;
            }
            this.updatedProps.forEach((props) => {
                const field = this.$el.querySelector(`.${props}`);
                // console.warn('props', field ? field : props);
                if (field) {
                    field.classList.add('updated');
                }
            });
        },
    },
};
</script>
